/**
 *  @class
 *  @function CollectionTabs
 */

if (!customElements.get('collection-tabs')) {
  class CollectionTabs extends HTMLElement {
    connectedCallback() {
      this.target = this.dataset.target;
      this.sectionRoot = this.closest('.section-collection-tabs') || this.closest('.shopify-section') || document;

      // buttons are outside <collection-tabs>, so search in section root
      this.buttons = Array.from(this.sectionRoot.querySelectorAll('.collection-tabs__list-link'));

      this.onButtonClick = this.onButtonClick.bind(this);

      this.buttons.forEach((button) => {
        button.addEventListener('click', this.onButtonClick);
      });

      if (Shopify.designMode) {
        this.addEventListener('shopify:block:select', (event) => {
          const handle = event.target?.dataset?.collection;
          if (!handle) return;

          const btn = this.buttons.find(b => b.dataset.collection === handle);
          if (btn) btn.click();
        });
      }
    }

    disconnectedCallback() {
      if (!this.buttons) return;
      this.buttons.forEach((button) => {
        button.removeEventListener('click', this.onButtonClick);
      });
    }

    onButtonClick(event) {
      const button = event.currentTarget;
      const handle = button.dataset.collection;

      this.buttons.forEach((el) => el.classList.remove('active'));
      button.classList.add('active');

      if (handle) this.toggleCollection(handle);

      event.preventDefault();
    }

    toggleCollection(handle) {
      const panelsWrap = document.getElementById(this.target);
      if (!panelsWrap) return;

      const panels = Array.from(panelsWrap.querySelectorAll('.collection-tabs__panel'));
      const nextPanel = panels.find((p) => p.dataset.collection === handle);
      if (!nextPanel) return;

      panels.forEach((p) => p.classList.toggle('is-active', p === nextPanel));

      if(colorSchemeInit) {
        colorSchemeInit();
      }

      // Resize Flickity AFTER panel becomes visible
      requestAnimationFrame(() => {
        const slider = nextPanel.querySelector('slide-show');
        if (!slider) return;

        // Try to find the actual Flickity element/instance
        const flickityEl =
          slider.classList.contains('flickity-enabled')
            ? slider
            : slider.querySelector('.flickity-enabled') || slider;

        const flkty =
          flickityEl?.flkty ||
          (window.Flickity && window.Flickity.data ? window.Flickity.data(flickityEl) : null);

        if (flkty) {
          flkty.resize();
          flkty.select(0, false, true);
        }

        const pagination = flickityEl.parentNode.querySelector('.flickity-pagination') || flickityEl.querySelector('.flickity-pagination');

        function updatePagination(flkty, currentIndex) {
          if (!pagination) return;

          const viewportW = flkty.size.innerWidth;
          let visible = 0;
          let acc = 0;

          flkty.cells.forEach((cell) => {
            const w = cell.size.outerWidth;
            if (acc + w <= viewportW + 1) {
              visible++;
              acc += w;
            }
          });

          visible = Math.max(1, visible);
          const totalPages = Math.max(1, flkty.cells.length - visible + 1);

          const totalEl = pagination.querySelector('.flickity-pagination--total');
          const currentEl = pagination.querySelector('.flickity-pagination--current');

          if (totalEl) totalEl.textContent = totalPages;
          if (currentEl) currentEl.textContent = Math.min(currentIndex + 1, totalPages);
        }

        updatePagination(flkty, flkty.selectedIndex);
      });
    }
  }

  customElements.define('collection-tabs', CollectionTabs);
}